// extracted by css-extract-rspack-plugin
export default {"progress":"progress-MB9Wr3"};